{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "Vaše zpětná vazba a návrhy nám pomohou zlepšit náš produkt a služby.",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "Pokud máte technický nebo podpůrný problém, nebo potřebujete okamžitou pomoc, kontaktujte prosím svého Laserfiche administrátora nebo poskytovatele řešení, jak je uvedeno ve vaší servisní smlouvě.",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "Našli jste něco, co se vám líbí nebo nelíbí? Dejte nám o tom vědět.",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "Máte nápad na novou funkci nebo vylepšení? Těšíme se, až se o něm dozvíme.",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "Do své zpětné vazby prosím nezahrnujte žádné důvěrné nebo osobní informace",
  "TELL_US_ABOUT_EXPERIENCE": "Řekněte nám o svých zkušenostech",
  "TELL_US_ABOUT_IDEA": "Řekněte nám o svém nápadu",
  "I_HAVE_FEEDBACK": "Mám zpětnou vazbu",
  "I_HAVE_SUGGESTION": "Mám návrh",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "Můžete mě kontaktovat ohledně této zpětné vazby",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "Pokud byste se chtěli připojit k našemu zákaznickému panelu,",
  "PLEASE_CLICK_HERE": "klikněte prosím zde.",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "Obrázek překračuje maximální velikost souboru {0}.",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "Obrázek je poškozený nebo ve formátu, který není rozpoznán.",
  "ACCEPTED_FORMATS_ARE_0": "Přijaté formáty jsou: {0}.",
  "IMAGE_NOT_ATTACHED": "Obrázek nebyl připojen.",
  "ATTACH_IMAGE": "Připojit obrázek",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "Připojte prosím pouze jeden obrázek.",
  "TAGS": "Štítky",
  "ADD_TAGS": "Přidat štítky",
  "ADD_MORE_TAGS": "Přidat další štítky",
  "NO_TAGS_AVAILABLE": "Nejsou k dispozici žádné štítky"
}
